import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const ProtectedRoute = (props) => {
  const { isAuthenticated, exact, path, render } = props
  if (isAuthenticated) {
    return <Route exact={exact} path={path} render={render} />
  } else {
    return <Redirect to='/' />
  }
}

export default ProtectedRoute



// WEBPACK FOOTER //
// ./src/components/routes/ProtectedRoute.js